module.exports = __webpack_public_path__ + "static/media/YM81_6.63ed60ce.jpg";